import { render } from "./CampaignApp.vue?vue&type=template&id=5012bb3a&scoped=true"
import script from "./CampaignApp.vue?vue&type=script&lang=js"
export * from "./CampaignApp.vue?vue&type=script&lang=js"

import "./CampaignApp.vue?vue&type=style&index=0&id=5012bb3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5012bb3a"]])

export default __exports__